import { render } from "./TV.vue?vue&type=template&id=6ee49d5f&scoped=true"
import script from "./TV.vue?vue&type=script&lang=js"
export * from "./TV.vue?vue&type=script&lang=js"

import "./TV.vue?vue&type=style&index=0&id=6ee49d5f&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee49d5f"]])

export default __exports__